export const documentTypes = [
  'C.I. Paraguaya',
  'D.N.I. Argentina',
  'R.G. Brasileña',
  'C.I. Venozenala',
  'D.G.M. Permanente',
  'D.G.M. Provisória',
]
